











































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { EditorProfile } from "@/services/editorProfiles/types";
import { getEditorProfiles } from "@/services/editorProfiles/editorProfilesService";
import { editorProfilesFields } from "@/components/editorProfiles/fields/editorProfilesFields";
import EditorProfileDeleteModal from "@/components/editorProfiles/modals/EditorProfileDeleteModal.vue";
@Component({
    components: { EditorProfileDeleteModal }
})
export default class EditorProfiles extends Vue {
    @Getter("reload") reload: any;

    // local state
    editorProfiles = [] as Array<EditorProfile>;
    editorProfileDeleteId: string = "";
    isBusy = false;
    fields = editorProfilesFields;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks
    public created(): void {
        this.fetchData();
    }

    // computed
    get filteredData() {
        return this.editorProfiles && this.editorProfiles
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }
    // methods

    deleteEditorProfile(editorProfile: EditorProfile) {
        (this.$refs.editorProfileDeleteModal as any).open(editorProfile);
    }

    fetchData() {
        this.isBusy = true;
        getEditorProfiles().then(response => {
            this.editorProfiles = response;
            this.isBusy = false;
        });
    }
}
